export default __webpack_public_path__ + "static/media/nuts_level_2.a1720c52.geojson";